import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import {OrderSummaryDataHook} from '../../OrderSummary';
import {DestinationPicker} from '../DestinationPicker/DestinationPicker';
import {TotalGroup} from '../TotalGroup/TotalGroup';

export const EstimatedTax = () => {
  const {
    cartStore: {
      cartSummary: {
        taxSummary: {taxes},
      },
      moveCartToViewerContext,
    },
    orderStore: {taxName: taxNameOld},
  } = useControllerProps();

  const {t} = useTranslation();

  return (
    <TotalGroup
      dataHook={OrderSummaryDataHook.EstimatedTaxRoot}
      totals={taxes.map(({name, amount}, index) => ({
        title: moveCartToViewerContext ? name || t('cart.estimated_tax') : taxNameOld || t('cart.estimated_tax'),
        value: amount.formattedConvertedAmount,
        key: index.toString(),
        additionalAttributes: {'data-wix-estimated-tax-price': 'EstimatedTax.EstimatedTaxEstimatedTaxPrice'},
      }))}
      title={''}
      suffix={<EstimatedTaxSuffix />}
    />
  );
};

export const EstimatedTaxSuffix = () => {
  const {
    orderStore: {shouldDisplayTaxDestinationPicker},
  } = useControllerProps();
  if (!shouldDisplayTaxDestinationPicker) {
    return undefined;
  }
  return <DestinationPicker dataHook={OrderSummaryDataHook.TaxDestinationPickerRoot} />;
};
